const hamburger = () => {
    document.getElementById('line1').classList.toggle('is-line_1');
    document.getElementById('line2').classList.toggle('is-line_2');
    document.getElementById('line3').classList.toggle('is-line_3');
    document.getElementById('spNav').classList.toggle('is-in');
}
document.getElementById('hamburger').addEventListener('click', function() {
    hamburger();
});